import { useNuxtApp } from "#app";
import { toValue } from "#imports";
export const useSafeI18nNumber = ({
  extraSentryData = {},
  sentryTags = {}
}) => {
  const {
    $i18n: { n },
    $sentry
  } = useNuxtApp();
  const safeI18nNumber = (...args) => {
    try {
      return n(...args);
    } catch (e) {
      if (e instanceof Error && $sentry?.captureException) {
        $sentry.captureException(e, { extra: { args, ...toValue(extraSentryData), tags: toValue(sentryTags) } });
      } else {
        console.error(e);
      }
    }
    return "";
  };
  return { safeI18nNumber };
};
